export const CO_GET_PACKAGING_LISTING = "CO_GET_PACKAGING_LISTING"
export const CO_GET_PACKAGING_LISTING_SUCCESS =
  "CO_GET_PACKAGING_LISTING_SUCCESS"
export const CO_GET_PACKAGING_LISTING_FAILED = "CO_GET_PACKAGING_LISTING_FAILED"
